(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/fraction-payment/assets/javascripts/pay-button-multiple-shares.js') >= 0) return;  svs.modules.push('/components/marketplace/fraction-payment/assets/javascripts/pay-button-multiple-shares.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState;
const Button = svs.ui.Button;
const _svs$ui$reactForm = svs.ui.reactForm,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Select = _svs$ui$reactForm.Select,
  Option = _svs$ui$reactForm.Option;
const urlMapping = svs.core.urlMapping;

const PayButtonMultipleShares = _ref => {
  let cantBuy = _ref.cantBuy,
    cantBuyReason = _ref.cantBuyReason,
    elemRef = _ref.elemRef,
    fractionPurchaseLoading = _ref.fractionPurchaseLoading,
    isSmall = _ref.isSmall,
    numberOfSharesLeft = _ref.numberOfSharesLeft,
    onClick = _ref.onClick,
    trackingLabel = _ref.trackingLabel;
  const _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    numberOfShares = _useState2[0],
    setNumberOfShares = _useState2[1];
  const selectNumberOfShares = noOfShares => {
    sessionStorage.setItem('pendingNumberOfShares', noOfShares);
    setNumberOfShares(noOfShares);
  };
  const getBuyButtonText = (cantBuy, cantBuyReason, fractionPurchaseLoading) => {
    const suffix = numberOfShares > 1 ? 'andelar' : 'andel';
    if (cantBuy && cantBuyReason) {
      return cantBuyReason;
    }
    if (fractionPurchaseLoading) {
      return 'Betalar..';
    }
    return "K\xF6p ".concat(numberOfShares, " ").concat(suffix);
  };
  const maxShares = Math.min(numberOfSharesLeft, 10);
  const numberOfSharesList = Array.from({
    length: maxShares
  }, (_, i) => i + 1);
  const isAuthenticated = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const currentReturnUrl = encodeURIComponent(location.pathname);
  const loginUrl = "".concat(urlMapping.get('loginHome'), "?returnUrl=").concat(currentReturnUrl);
  return React.createElement("section", {
    className: "pay-button-multiple-shares"
  }, maxShares > 1 && React.createElement(React.Fragment, null, React.createElement("p", {
    className: "select-description"
  }, "Antal:"), React.createElement(ControlGroup, {
    className: "margin-right-1",
    v2: true
  }, React.createElement(Select, {
    "aria-label": "Antal andelar",
    className: "margin-bottom-1 select-number-of-shares",
    "data-testid": "mkp-number-of-shares-select",
    disabled: cantBuy,
    name: "Antal andelar",
    onChange: event => {
      const value = Number(event.target.value);
      svs.components.analytics.trackEvent({
        category: 'Tillsammans',
        action: 'number of shares drop down',
        opt_label: trackingLabel,
        opt_value: value
      });
      selectNumberOfShares(value);
    },
    v2: true,
    value: "".concat(numberOfShares)
  }, numberOfSharesList.map((noOfShares, index) =>
  React.createElement(Option, {
    key: "".concat(index, "_").concat(noOfShares),
    value: "".concat(noOfShares)
  }, "".concat(noOfShares)))))), React.createElement(Button, {
    block: true,
    className: "pay-fraction-button qa-pay-fraction-button",
    "data-testid": "qa-pay-fraction-button",
    disabled: cantBuy,
    elemRef: elemRef,
    href: !isAuthenticated ? loginUrl : undefined,
    inverted: true,
    onClick: event => {
      if (isAuthenticated) {
        event === null || event === void 0 || event.preventDefault();
        event === null || event === void 0 || event.stopPropagation();
        onClick(numberOfShares);
        setNumberOfShares(1);
      }
    },
    onKeyDownCapture: event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.stopPropagation();
      }
    },
    size: isSmall ? 100 : 300
  }, getBuyButtonText(cantBuy, cantBuyReason, fractionPurchaseLoading)));
};
setGlobal('svs.components.marketplace.fractionPayment.PayButtonMultipleShares', PayButtonMultipleShares);

 })(window);